import(/* webpackMode: "eager" */ "/home/runner/work/ctv-partners-fe/ctv-partners-fe/src/app/[locale]/page.tsx");
